import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-default" }

import Header from "@/components/Header.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutDefault',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createElementVNode("main", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})